export const landingPageStyles = {
  sponsorBox: {
    border: '1px',
    margin: '10px',
    padding: '10px',
    width: '90%',
    borderStyle: 'dotted',
    spacing: '30px',
  },

  container: {
    maxWidth: { base: '350px', lg: '650px' },
    margin: { base: '10px auto', lg: '40px auto' },
    alignItems: 'center',
  },

  questionsBox: {
    alignItems: 'center',
    width: 'full',
  },

  questionsContent: {
    spacing: '2',
    width: 'full',
  },

  welcomeTextBox: {
    spacing: '2',
  },

  wrapContainer: {
    padding: '30px',
    justify: 'center',
  },

  welcomeImage: {
    // border: '1px',
    // rounded: 'md',
    w: '500px',
    h: 'auto',
  },

  welcomeAdditionalText: {
    fontSize: 'xl',
  },

  promoTextContainer: {
    padding: '0px',
    width: { base: '100%', md: '45%' },
    justifyContent: 'leading',
    alignItems: 'leading',
    fontWeight: '400',
  },

  explainerVideoContainer: {
    width: { base: '100%', md: '750px' },
    padding: '8px',
  },

  explainerVideo: {
    width: { base: '90vw', md: '750px' },
    height: { base: 'calc(90vw * 0.5625)', md: '421px' },
  },

  faqContainer: {
    width: { base: '100%', md: '750px' },
    justifyContent: 'leading',
    alignItems: 'leading',
    padding: '8px',
  },

  faqListContainer: {
    width: '100%',
    justifyContent: 'leading',
    alignItems: 'leading',
    padding: { base: '8px', sm: '16px', md: '32px' },
    gap: '20px',
  },

  faqQuestion: {
    fontWeight: '700',
    fontSize: 'md',
  },

  faqAnswer: {
    fontWeight: '400',
    fontSize: 'md',
  },

  promoTextHighlight: {
    fontWeight: '700',
  },

  promoTagLine: {
    fontWeight: '700',
    fontSize: 'xl',
  },

  benefitsList: {
    padding: '0 0 0 25px',
  },

  promoImage: {
    width: { base: '350px', sm: '45%' },
    height: 'auto',
  },

  lowerPromoTextContainer: {
    width: { base: '100%', sm: '50%' },
    alignItems: 'center',
  },

  faqTitle: {
    fontSize: 'xl',
    fontWeight: '700',
  },

  getStartedBox: {
    marginTop: '80px',
    alignItems: 'center',
  },

  getStartedButton: {
    marginTop: '18px',
    width: '221px',
    height: '56px',
    backgroundColor: 'brand.green.100',
    color: 'white',
    _hover: {
      backgroundColor: 'brand.green.200',
    },
  },

  footnote: {
    fontSize: '10px',
  },

  errorText: {
    color: 'red',
  },
};
